import { t } from "@lingui/macro";
import { Box, Typography } from "@mui/material";

function HistoryBlankState() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
    >
      <Typography variant="prose-md">{t`No historical data available`}</Typography>
    </Box>
  );
}

export default HistoryBlankState;
